import _objectDestructuringEmpty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _extends from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { getBillingProfileAdapter, checkToRedirectOnSuccess, currencyPackageTransformer } from './adapter';
import { PURCHASE_CACHE_TAGS, GAME_CACHE_TAGS } from '../tags';
import { handleQueryLoggerEvents } from '../handleLoggerErrorEvents';
import { Endpoints } from '../../../api/Constants';
import Logger from '../../../lib/analytics/logger';
import { setActiveConsumables } from '../../slices/consumables/consumables';
import ERROR_CODE from '../../../utils/errorCodes';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
var finishMobilePurchaseEndpoint = Endpoints.FINISH_MOBILE_PURCHASE;
var buyItemWithBillingProfileEndpoint = Endpoints.BILLING_PROFILE_PURCHASE;
var getBillingProfilesEndpoint = Endpoints.GET_BILLING_PROFILES;
var removeBillingProfilesEndpoint = Endpoints.REMOVE_BILLING_PROFILE;
var getAddressForPurchaseEndpoint = Endpoints.GET_PURCHASE_ADDRESS;
var startWebPurchaseEndpoint = Endpoints.START_WEB_PURCHASE;
var finishWebPurchaseEndpoint = Endpoints.FINISH_WEB_PURCHASE;
var refreshActiveConsumablesEndpoint = Endpoints.GET_ACTIVE_CONSUMABLES;
var getCurrencyPackagesEndpoint = Endpoints.GET_CURRENCY_PACKAGES;
export var postFinishMobilePurchaseMutation = {
  query: function query(data) {
    return {
      url: finishMobilePurchaseEndpoint,
      body: {
        data: data
      },
      method: 'post'
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  invalidatesTags: [{
    type: PURCHASE_CACHE_TAGS.REFRESH_CONSUMABLES
  }, {
    type: GAME_CACHE_TAGS.GET_GAME_ROOMS
  }],
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args, _ref) {
      var queryFulfilled, getState;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            queryFulfilled = _ref.queryFulfilled, getState = _ref.getState;
            _context.prev = 1;
            _context.next = 4;
            return queryFulfilled;
          case 4:
            _context.next = 9;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);
            handleQueryLoggerEvents(_context.t0, getState, finishMobilePurchaseEndpoint);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 6]]);
    }));
    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var postBuyItemWithBillingProfileMutation = {
  query: function query(data) {
    return {
      url: buyItemWithBillingProfileEndpoint,
      body: {
        data: data
      },
      method: 'post'
    };
  },
  transformResponse: function transformResponse(response) {
    return response['0'];
  },
  invalidatesTags: function invalidatesTags(result) {
    return result !== null && result !== void 0 && result.success ? [{
      type: PURCHASE_CACHE_TAGS.REFRESH_CONSUMABLES
    }, {
      type: GAME_CACHE_TAGS.GET_GAME_ROOMS
    }] : [];
  },
  onQueryStarted: function () {
    var _onQueryStarted2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_, _ref2) {
      var queryFulfilled, getState;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            queryFulfilled = _ref2.queryFulfilled, getState = _ref2.getState;
            _context2.prev = 1;
            _context2.next = 4;
            return queryFulfilled;
          case 4:
            _context2.next = 9;
            break;
          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](1);
            handleQueryLoggerEvents(_context2.t0, getState, finishMobilePurchaseEndpoint);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 6]]);
    }));
    function onQueryStarted(_x3, _x4) {
      return _onQueryStarted2.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var getBillingProfilesQuery = {
  query: function query() {
    return {
      url: getBillingProfilesEndpoint
    };
  },
  transformResponse: function transformResponse(response) {
    return getBillingProfileAdapter(response[0]);
  },
  onQueryStarted: function () {
    var _onQueryStarted3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_, _ref3) {
      var queryFulfilled;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            queryFulfilled = _ref3.queryFulfilled;
            _context3.prev = 1;
            _context3.next = 4;
            return queryFulfilled;
          case 4:
            _context3.next = 9;
            break;
          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3["catch"](1);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context3.t0, Object.getOwnPropertyNames(_context3.t0)),
              code: ERROR_CODE.GET_BILLING_PROFILES_ERROR
            });
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 6]]);
    }));
    function onQueryStarted(_x5, _x6) {
      return _onQueryStarted3.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var postRemoveBillingProfileMutation = {
  query: function query(data) {
    return {
      url: removeBillingProfilesEndpoint,
      body: {
        data: data
      },
      method: 'post'
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(data, _ref4) {
      var queryFulfilled;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            queryFulfilled = _ref4.queryFulfilled;
            _context4.prev = 1;
            _context4.next = 4;
            return queryFulfilled;
          case 4:
            _context4.next = 9;
            break;
          case 6:
            _context4.prev = 6;
            _context4.t0 = _context4["catch"](1);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              pid: data === null || data === void 0 ? void 0 : data.profile,
              error: JSON.stringify(_context4.t0, Object.getOwnPropertyNames(_context4.t0)),
              code: ERROR_CODE.REMOVE_BILLING_PROFILE_ERROR
            });
          case 9:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 6]]);
    }));
    function onQueryStarted(_x7, _x8) {
      return _onQueryStarted4.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var getAddressForPurchaseQuery = {
  query: function query() {
    return {
      url: getAddressForPurchaseEndpoint
    };
  },
  transformResponse: function transformResponse(response) {
    return response['0'];
  },
  onQueryStarted: function () {
    var _onQueryStarted5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_, _ref5) {
      var queryFulfilled;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            queryFulfilled = _ref5.queryFulfilled;
            _context5.prev = 1;
            _context5.next = 4;
            return queryFulfilled;
          case 4:
            _context5.next = 9;
            break;
          case 6:
            _context5.prev = 6;
            _context5.t0 = _context5["catch"](1);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context5.t0, Object.getOwnPropertyNames(_context5.t0)),
              code: ERROR_CODE.GET_ADDRESS_FOR_PURCHASE_ERROR
            });
          case 9:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 6]]);
    }));
    function onQueryStarted(_x9, _x10) {
      return _onQueryStarted5.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var postStartWebPurchaseMutation = {
  query: function query(payload) {
    var data = _extends({}, (_objectDestructuringEmpty(payload), payload));
    return {
      url: startWebPurchaseEndpoint,
      body: {
        data: data
      },
      method: 'post'
    };
  },
  transformResponse: function transformResponse(response) {
    return response[0];
  },
  onQueryStarted: function () {
    var _onQueryStarted6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(data, _ref6) {
      var queryFulfilled, _yield$queryFulfilled, response;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            queryFulfilled = _ref6.queryFulfilled;
            _context6.prev = 1;
            _context6.next = 4;
            return queryFulfilled;
          case 4:
            _yield$queryFulfilled = _context6.sent;
            response = _yield$queryFulfilled.data;
            checkToRedirectOnSuccess(data, response);
            _context6.next = 12;
            break;
          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](1);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context6.t0, Object.getOwnPropertyNames(_context6.t0)),
              code: ERROR_CODE.START_WEB_PURCHASE_ERROR
            });
          case 12:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[1, 9]]);
    }));
    function onQueryStarted(_x11, _x12) {
      return _onQueryStarted6.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var postFinishWebPurchaseMutation = {
  query: function query(data) {
    return {
      url: finishWebPurchaseEndpoint,
      body: {
        data: data
      },
      method: 'post'
    };
  },
  transformResponse: function transformResponse(response) {
    return response[0];
  },
  invalidatesTags: [{
    type: PURCHASE_CACHE_TAGS.REFRESH_CONSUMABLES
  }, {
    type: GAME_CACHE_TAGS.GET_GAME_ROOMS
  }],
  onQueryStarted: function () {
    var _onQueryStarted7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(_, _ref7) {
      var queryFulfilled;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            queryFulfilled = _ref7.queryFulfilled;
            _context7.prev = 1;
            _context7.next = 4;
            return queryFulfilled;
          case 4:
            _context7.next = 9;
            break;
          case 6:
            _context7.prev = 6;
            _context7.t0 = _context7["catch"](1);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context7.t0, Object.getOwnPropertyNames(_context7.t0)),
              code: ERROR_CODE.FINISH_WEB_PURCHASE_ERROR
            });
          case 9:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[1, 6]]);
    }));
    function onQueryStarted(_x13, _x14) {
      return _onQueryStarted7.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var getRefreshActiveConsumablesQuery = {
  query: function query() {
    return {
      url: refreshActiveConsumablesEndpoint,
      body: {
        cache: {
          ignoreCache: true
        }
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response['0'];
  },
  providesTags: function providesTags() {
    return [{
      type: PURCHASE_CACHE_TAGS.REFRESH_CONSUMABLES
    }];
  },
  onQueryStarted: function () {
    var _onQueryStarted8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(_, _ref8) {
      var queryFulfilled, dispatch, _yield$queryFulfilled2, activeConsumables;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            queryFulfilled = _ref8.queryFulfilled, dispatch = _ref8.dispatch;
            _context8.prev = 1;
            _context8.next = 4;
            return queryFulfilled;
          case 4:
            _yield$queryFulfilled2 = _context8.sent;
            activeConsumables = _yield$queryFulfilled2.data;
            dispatch(setActiveConsumables(activeConsumables));
            _context8.next = 12;
            break;
          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](1);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context8.t0, Object.getOwnPropertyNames(_context8.t0)),
              code: ERROR_CODE.REFRESH_ACTIVE_CONSUMABLES_ERROR
            });
          case 12:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[1, 9]]);
    }));
    function onQueryStarted(_x15, _x16) {
      return _onQueryStarted8.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var getCurrencyPackagesQuery = {
  query: function query() {
    var promoValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return {
      url: promoValue ? "".concat(getCurrencyPackagesEndpoint).concat(promoValue) : getCurrencyPackagesEndpoint,
      body: {
        cache: {
          ignoreCache: true
        }
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return currencyPackageTransformer(response[0]);
  },
  onQueryStarted: function () {
    var _onQueryStarted9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(_, _ref9) {
      var queryFulfilled;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            queryFulfilled = _ref9.queryFulfilled;
            _context9.prev = 1;
            _context9.next = 4;
            return queryFulfilled;
          case 4:
            _context9.next = 9;
            break;
          case 6:
            _context9.prev = 6;
            _context9.t0 = _context9["catch"](1);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context9.t0, Object.getOwnPropertyNames(_context9.t0)),
              code: ERROR_CODE.GET_CURRENCY_PACKAGES_ERROR
            });
          case 9:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[1, 6]]);
    }));
    function onQueryStarted(_x17, _x18) {
      return _onQueryStarted9.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};